import React from 'react';

import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import Button from '../UI/Button';
import LoadingBtn from '../UI/LoadingBtn';

const ConfirmationModal = (prop) => {
  const { header, body, onYes, onNo, isOpen, loading } = prop;

  return (
    <Modal
      isOpen={isOpen}
      size="sm"
      backdrop={false}
      fullscreen="sm"
      className="confirmation-modal"
      centered={true}
    >
      <ModalHeader className="confirmation-modal-header">{header}</ModalHeader>
      <ModalBody className="confirmation-modal-body">{body}</ModalBody>
      <ModalFooter className="confirmation-modal-footer">
        {loading ? (
          <LoadingBtn title="Submitting..." />
        ) : (
          <React.Fragment>
            <Button title="No" onClick={onNo} />
            <Button title="Yes" onClick={onYes} />
          </React.Fragment>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmationModal;
